import Details from '@admin/components/details'
import Button from '@admin/components/button'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

const Overview = ({ advisor }) => {

  const design_url = {
    label: 'view design assets',
    className: 'link',
    link: advisor.aesthetic_profile.design_url
  }

  const details = {
    sections: [
      {
        title: 't(Advisor Details)',
        items: [
          { label: 't(Name)', content: advisor.name },
          { label: 't(Organization)', content: advisor.organization },
          { label: 't(Aesthetic Profile)', show: advisor.aesthetic_profile !== null, content: (
            <>
              { advisor.aesthetic_profile.title } { advisor.aesthetic_profile.design_url &&
                <>(<Button { ...design_url } />)</>
              }
            </>
          ) }
        ]
      }
    ]
  }

  return <Details { ...details } />

}

Overview.propTypes = {
  advisor: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview advisor={ props.advisor } />
})

const mapResourcesToPanel = (props, context) => ({
  advisor: '/api/admin/truevail/advisor'
})

export default Panel(mapResourcesToPanel, mapPropsToPanel)
